import React from 'react';

interface Props {
  x: number;
  y: number;
  colour: string;
  bold: boolean;
  italic: boolean;
  underline: boolean;
  fontFamily: string;
  listStyle: 'none' | 'bullet';
  fontSize: number;
  onChange: (partial: { color?: string; bold?: boolean; italic?: boolean; underline?: boolean; fontSize?: number; fontFamily?: string; listStyle?: 'none' | 'bullet' }) => void;
  onDelete: () => void;
  onClose: () => void;
}

const COLORS = ['#fef08a', '#fbcfe8', '#bbf7d0', '#bfdbfe', '#ddd6fe'];

const StickyNoteToolbar: React.FC<Props> = ({ x, y, colour, bold, italic, underline, fontFamily, listStyle, fontSize, onChange, onClose, onDelete }) => {
  const [showPalette,setShowPalette] = React.useState(false);
  const FONTS = ['Inter', 'Serif', 'Mono'];
  const [showFont,setShowFont]=React.useState(false);

  return (
    <div
      className="absolute z-50 bg-gray-900/90 text-white rounded-lg shadow-xl flex items-center gap-2 px-3 py-2"
      style={{ left: x, top: y }}
      onMouseLeave={()=>setShowPalette(false)}
    >
      {/* Colour picker */}
      <div className="relative">
        <button className="w-4 h-4 rounded-full border-2 border-white" style={{backgroundColor: colour}} onClick={()=>setShowPalette(p=>!p)} />
        {showPalette && (
          <div className="absolute -left-4 top-6 bg-gray-800/95 p-2 rounded-md flex gap-1">
            {COLORS.map(c=>(
              <div key={c} className={`w-4 h-4 rounded-full border-2 ${colour===c?'border-blue-400':'border-transparent'} cursor-pointer`} style={{backgroundColor:c}} onClick={()=>{onChange({color:c}); setShowPalette(false);}} />
            ))}
          </div>
        )}
      </div>
      {/* Font family */}
      <div className="relative">
        <button className="px-2 text-xs rounded hover:bg-gray-700" onClick={()=>setShowFont(s=>!s)}>{fontFamily.slice(0,2)}▾</button>
        {showFont && (
          <div className="absolute left-0 top-6 bg-gray-800/95 rounded-md shadow p-1">
            {FONTS.map(f=>(
              <div key={f} className="px-3 py-1 hover:bg-gray-700 cursor-pointer" style={{fontFamily:f}} onClick={()=>{onChange({fontFamily:f}); setShowFont(false);}}>{f}</div>
            ))}
          </div>
        )}
      </div>
      {/* Font size */}
      <div className="flex items-center gap-1">
        <button className="px-1 text-xs hover:bg-gray-700 rounded" onClick={()=>onChange({fontSize: fontSize-1})}>A-</button>
        <span className="text-xs w-5 text-center">{fontSize}</span>
        <button className="px-1 text-xs hover:bg-gray-700 rounded" onClick={()=>onChange({fontSize: fontSize+1})}>A+</button>
      </div>
      {/* Text styles */}
      <button className={`px-1 text-sm font-bold rounded ${bold?'bg-gray-700':''}`} onClick={()=>onChange({bold: !bold})}>B</button>
      <button className={`px-1 italic text-sm rounded ${italic?'bg-gray-700':''}`} onClick={()=>onChange({italic: !italic})}>I</button>
      <button className={`px-1 underline text-sm rounded ${underline?'bg-gray-700':''}`} onClick={()=>onChange({underline: !underline})}>U</button>
      <button className={`px-1 text-sm rounded ${listStyle==='bullet'?'bg-gray-700':''}`} onClick={()=>onChange({listStyle: listStyle==='bullet'?'none':'bullet'})}>•</button>

      <button className="px-1 ml-2 hover:bg-red-600 rounded" onClick={onDelete}>🗑</button>
      <button className="text-xs ml-1" onClick={onClose}>✕</button>
    </div>
  );
};

export default StickyNoteToolbar; 